import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app.component';
import { AuthService } from './app/core/auth/services/auth.service';

function renderFatalError(error: unknown): void {
  const fallback = document.querySelector<HTMLElement>('[data-mg3p-bootstrap-fallback]');
  if (!fallback) {
    return;
  }
  const message = error instanceof Error ? error.message : 'Erro desconhecido';
  fallback.innerHTML = `
    <div class="mg3p-bootstrap-fallback__card" role="alert">
      <p class="mg3p-bootstrap-fallback__title">Não foi possível iniciar o portal MG3P-PMDF</p>
      <p class="mg3p-bootstrap-fallback__message">
        Verifique se o Keycloak está acessível em
        <code>http://localhost:8081</code> e se a infraestrutura local está ativa
        (<code>docker compose up -d</code>).
      </p>
      <p class="mg3p-bootstrap-fallback__message" style="margin-top:0.75rem;">
        Detalhe técnico: ${message}
      </p>
    </div>
  `;
}

async function bootstrap(): Promise<void> {
  const appRef = await bootstrapApplication(App, appConfig);
  const authService = appRef.injector.get(AuthService);
  authService.checkAuth().subscribe({
    error: (error) => {
      console.error('Falha ao verificar autenticacao inicial.', error);
    },
  });
}

void bootstrap().catch((error) => {
  console.error('Falha ao inicializar o app MG3P frontend.', error);
  renderFatalError(error);
});
